import {
  DealerMappingType,
  RestrictFactors,
} from 'src/modules/CallDirectory/types';
import { BrowsingMode } from '../constants';
import { HomepageParent, HomepageWidgetList, WidgetData } from './HomepageData';
import {
  AllUsersListingParent,
  ClientListingType,
  SearchDataType,
} from './Listing';
import ClientDetails from './ClientDetails';

type Store = {
  homepage: HomepageParent;
  referralData: {
    list: ClientDetails[];
    apiStatus: string;
    page: number;
    limit: number;
    hasMore: boolean;
    input: string;
  };
  allUsersListing: AllUsersListingParent;
  societyData: {
    data: WidgetData;
    apiStatus: string;
    page: number;
    limit: number;
    hasMore: boolean;
  };
  hasNoCar: boolean;
  clientCarsData: {
    carsData: {
      apiStatus: string | null;
      list: any[];
    };
    modelClients: {
      [key: string]: ClientListingType;
    };
    clientId: string;
  };
  searchData: SearchDataType;
  browsingMode: BrowsingMode;
  restrictData: RestrictFactors;
  currentDealer: DealerMappingType;
};

export const initHomepageData: HomepageWidgetList = {
  areContactsSynced: false,
  haveSyncPermission: null,
  clientCount: 0,
  widgets: [],
};

export default Store;
